<template>
  <v-container
    id="goal"
    tag="section" fluid
  >
    <v-row align="center"
        justify="center">
      <v-col cols="12" align="center" class="ml-5 pa-0">
        <v-card flat max-width="1130">
          <v-row align="start">
            <!-- <base-subheading><span class="headline">{{ $t('MeeTeeMeeNgern1.workWithUs') }}</span></base-subheading> -->
            <v-col align="start" cols="12" class="pa-0 ma-1">
              <span class="display-3"><strong>{{ $t('MeeTeeMeeNgern1.GoalHeader') }}</strong></span>
              <v-divider></v-divider>
            </v-col>
            <!-- <v-img
              :src="require(`@/assets/MeeTeeMeeNgern/1000x420px/goal_1000x420.jpg`)"
              height="100%">
            </v-img> -->
            <v-img
              :src="require(`@/assets/MeeTeeMeeNgern/banner3.png`)"
              height="10%">
            </v-img>
            <v-col cols="12" align="start" class="mb-0 pt-5">
              <div class="a">
                <p class="display-2">
                  ตามที่ภาครัฐได้มีนโยบายแก้ไขปัญหาหนี้สินของประชาชนรายย่อย ได้มอบหมายให้ธนาคารออมสินเป็นหน่วยงานหลักในการขับเคลื่อนการให้บริการสินเชื่อที่ดินและขายฝาก เพื่อช่วยเหลือประชาชนที่ต้องการเงินทุนไว้ใช้ในการประกอบการ เพื่อใช้จ่ายในครัวเรือน เพื่อลดภาระดอกเบี้ยที่มีอยู่ โดยรูปแบบเป็นการจัดตั้งบริษัทจำกัด โดยการร่วมทุนกับองค์กรที่มีภาครัฐเป็นผู้ถือหุ้นใหญ่อีก 2 แห่ง ผู้ถือหุ้นของบริษัทจึงประกอบด้วย <strong>ธนาคารออมสิน</strong> ถือหุ้นในสัดส่วน 49% <strong>บจก.ทิพย เอกซ์โพเนนเชียล</strong> 31% และ <strong>บมจ. บางจาก คอร์เปอเรชั่น</strong> 20% จัดตั้งบริษัทร่วมทุน  <span style="color:#E90587">“บริษัท มีที่ มีเงิน จำกัด”</span> โดยมีเป้าหมายในการพัฒนากลไก ขับเคลื่อนภารกิจเชิงสังคม ให้บริการสินเชื่อที่ดินและขายฝาก เพื่อลดดอกเบี้ยและเสริมสภาพคล่องให้กับประชาชนที่มีความจำเป็น ให้เข้าถึงแหล่งเงินทุนด้วยต้นทุนที่ต่ำลง โดยกลุ่มเป้าหมายหลัก ได้แก่ ประชาชนทั่วไป ผู้ประกอบการธุรกิจ SMEs เป็นต้น
                </p>
              </div>
              <div class="text-decoration-underline">
                <p class="display-2 font-weight-bold">
                  วิสัยทัศน์
                </p>
              </div>
              <div>
                <p class="display-2">
                  “เป็นหน่วยงาน ที่มีบทบาทในการสร้างการเข้าถึงแหล่งเงินทุนที่มีอัตราดอกเบี้ยและเงื่อนไขที่เป็นธรรม ส่งเสริมการขับเคลื่อนทางเศรษฐกิจของประเทศ”
                </p>
              </div>
              <div class="text-decoration-underline">
                <p class="display-2 font-weight-bold">
                  พันธกิจ
                </p>
              </div>
              <p class="a display-2">
                1. ส่งเสริมพันธกิจของผู้ถือหุ้นในด้านการเป็นสถาบันการเงินเพื่อสังคม
              </p>
              <p class="a display-2">
                2. ส่งเสริมการเข้าถึงแหล่งเงินทุนที่เป็นธรรม เพื่อลดความเหลื่อมล้ำ ภายใต้ความเสี่ยงที่ยอมรับได้
              </p>
              <p class="a display-2">
                3. บริหารจัดการหนี้ด้วยหลักการคุณธรรม ให้ความสำคัญกับประโยชน์สูงสุดของลูกค้า
              </p>
              <p class="a display-2">
                4. พัฒนาบุคลากรให้เชี่ยวชาญ สานต่อองค์กรด้วยแนวคิดใหม่ ๆ ประยุกต์ใช้เทคโนโลยีและนวัตกรรมเพื่อรองรับการเปลี่ยนแปลง
              </p>
              <p class="a display-2">
                5. กำกับดูแลกิจการภายใต้หลักการ กำกับกิจการที่ดี สร้างเครือข่ายพันธมิตรเพื่อขยายธุรกิจ และฐานลูกค้าอย่างบูรณาการ
              </p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
      <!-- <v-col cols="12" class="mb-0 pb-0">
        <span class="display-3">{{ $t('MeeTeeMeeNgern1.GoalHeader') }}</span>
        <v-divider></v-divider>
      </v-col>
      <v-img
        :src="require(`@/assets/MeeTeeMeeNgern/1000x420px/2.1.1000x42 px.jpg`)"
        height="100%">
      </v-img>
      <v-col cols="12" class="mb-0 pt-5">
        <p>
          <span class="display-1">
            1. มีอาชีพที่มั่นคงสามารถเลี้ยงดูครอบครัวได้ : อาชีพที่มั่นคงหากพูดถึงคำนี้หลายคนคงจะนึกอาชีพข้าราชการ ใช่ค่ะอาชีพรับราชการเป็นอาชีพที่มั่นคงก็จริงแต่ไม่ได้เป็นอาชีพเดียวที่จะมั่นคงได้ อาชีพอื่นๆเช่น การค้าขาย การทำธุรกิจส่วนตัว หรือแม้การเป็นพนักงานทั่วๆไปก็มั่นคงได้หากคุณรู้จักเก็บออม ขยันหมั่นเพียร คุณก็จะสามารถเลี้ยงดูครอบครัวได้เช่นกัน
          </span>
        </p>
        <p>
          <span class="display-1">
            2. มีเงินเดือนพอใช้จ่ายในทุกๆเดือน : เมื่อทำงานแล้วก็จะต้องมีเงินเดือนและเป้าหมายของผู้ที่มีเงินเดือนก็คือจะต้องบริหารเงินเดือนของคุณให้พอใช้จ่ายในแต่ละเดือน โดยไม่สร้างหนี้มีเท่าไหร่ใช้เท่านั้นหากมีมากเก็บมาก มีน้อยเก็บน้อยตามกำลังทรัพย์
          </span>
        </p>
        <p>
          <span class="display-1">
            3. ทำงานเสร็จทันเวลา : เป้าหมายการทำงานอีกอย่างหนึ่งที่คุณควรจะตั้งเป้าในแต่ละวันก็คือคุณจะทำงานที่ได้รับมอบหมายให้เสร็จทันเวลาโดยไม่ปล่อยให้งานพอกพูนจนเป็นดินพอกหางหมู
          </span>
        </p>
        <p>
          <span class="display-1">
            4. เจ้านายชื่นชม : การได้รับความชื่นชมนั้นเป็นกำลังที่ดีสำหรับคนทำงาน มันอาจไม่ใช่เป้าหมายทั้งหมดของชีวิตแต่เป็นเพียงยาใจเล็กๆน้อยๆ ที่ทำให้เห็นว่าการทำความดีของคุณนั้นยังมีคนที่มองเห็น
          </span>
        </p>
        <p>
          <span class="display-1">
            5. ทำงานสำเร็จตามที่ได้รับมอบหมาย : การทำงานที่ได้รับมอบหมายให้สำเร็จนั้นเปรียบเหมือนว่าคุณทำงานได้อย่างมีประสิทธิภาพ และมีคุณภาพ 
          </span>
        </p>
        <p>
          <span class="display-1">
            6. มีเพื่อนร่วมงานที่ดี : เพื่อนร่วมงานที่ดีจะช่วยสนับสนุนให้การทำงานของคุณประสบความสำเร็จไม่มีใครที่สามารถทำงานให้สำเร็จเพียงคนเดียวโดยปราศจากเพื่อนร่วมงาน และการมีเพื่อนร่วมงานที่ดีจะทำให้บรรยากาศในการทำงานของคุณมีแต่ความสุขเมื่อมีความสุขงานก็จะออกมาดีนั่นเอง
          </span>
        </p>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeAbout',
  }
</script>
<style scoped>
  div.a {
    text-indent: 50px;
  }

  p.a {
    margin-left: 2em;
    text-indent: -1.5em;
  }

  div.c {
    text-indent: 30%;
  }
</style>
